import React from 'react';
import PropTypes from 'prop-types';
import styles from '../../styles/views/components/ToggleButton.module.scss';

const ToggleButton = ({
  firstToggleButtonValue,
  secondToggleButtonValue,
  isDisabled,
  isPrimaryToggleChosen,
  firstToggleAction,
  secondToggleAction,
  className,
}) => (
  <div className={[styles.container, styles[className] || ''].join(' ')}>
    <button
      className={[styles.button, styles.leftBtn, isPrimaryToggleChosen ? styles.selected : ''].join(' ')}
      disabled={isDisabled}
      onClick={firstToggleAction}
    >
      <span>{firstToggleButtonValue}</span>
    </button>
    <button
      className={[styles.button, styles.rightBtn, !isPrimaryToggleChosen ? styles.selected : ''].join(' ')}
      disabled={isDisabled}
      onClick={secondToggleAction}
    >
      <span>{secondToggleButtonValue}</span>
    </button>
  </div>
);

ToggleButton.defaultProps = {
  isDisabled: false,
  isPrimaryToggleChosen: false,
  firstToggleAction: () => {},
  secondToggleAction: () => {},
  className: '',
};

ToggleButton.propTypes = {
  firstToggleButtonValue: PropTypes.string.isRequired,
  secondToggleButtonValue: PropTypes.string.isRequired,
  isDisabled: PropTypes.bool,
  isPrimaryToggleChosen: PropTypes.bool,
  firstToggleAction: PropTypes.func,
  secondToggleAction: PropTypes.func,
  className: PropTypes.string,
};

export default ToggleButton;
